import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Rating, Box, Typography, TextField
} from "@mui/material";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function RecipeRatingModal({ open, onClose, recipeId, onSubmitted }) {
  const { isLoggedIn, user } = useAuth();
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const payload = { rating: stars, comment };
      if (!isLoggedIn && user?.username) payload.username = user.username;
      await api.recipeReviews.add(recipeId, payload);
      if (onSubmitted) onSubmitted();
      onClose();
    } catch (e) {
      alert("Απέτυχε η υποβολή!");
      console.error(e);
    }
    setSubmitting(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Αξιολόγησε τη συνταγή</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 1 }}>Βαθμολόγησε με αστέρια</Typography>
          <Rating value={stars} onChange={(_, v) => setStars(v)} />
        </Box>
        <TextField
          label="Σχόλιο (προαιρετικό)"
          fullWidth
          multiline
          rows={2}
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Άκυρο</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!stars || submitting}>
          Υποβολή
        </Button>
      </DialogActions>
    </Dialog>
  );
}
